import "./Common.css";
export const CommonHeader = ({ title }) => {
  return (
    <div className="hero-section text-white text-center py-5">
      <h1 className="fw-bold">{title}</h1>
    </div>
  );
};
